import { createPinia } from 'pinia';
import piniaPersist from 'pinia-plugin-persistedstate';

export const pinia = createPinia();
pinia.use(piniaPersist);


        // You could inject plugins here later, for example:
        // pinia.use(somePlugin);
        // logger, localStorage plugins.

